import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import { useNavigate } from "react-router-dom";
import { portalChangePassword } from "../../services/portalService";
import { usePortalAuth } from "../../contexts/PortalAuthContext";
import InputField from "../../utils/InputField";
import { useToast } from '../../contexts/ToastContext';
import { useLoading } from "../../contexts/LoadingContext";

function PortalChangePassword() {
  const navigate = useNavigate();
  const { login } = usePortalAuth();
  const { showToast } = useToast();
  const { startLoading, stopLoading } = useLoading();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [serverError, setServerError] = useState("");

  const handleFieldChange = (field, value) => {
    if (field === "newPassword") setNewPassword(value);
    if (field === "confirmPassword") setConfirmPassword(value);
  };

  const validateForm = () => {
    const errors = {};
    if (!newPassword || newPassword.length < 8) {
      errors.newPassword = "Password must be at least 8 characters";
    }
    if (newPassword !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError("");

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    try {
      startLoading();
      await portalChangePassword(newPassword);
      showToast('Password updated successfully! Welcome to your dashboard.', 'success');
      
      // Update session with token that is already in localStorage
      const token = localStorage.getItem("portalToken");
      login(token);
    } catch (error) {
      showToast(error.message || "Failed to update password.", 'error');
      setServerError(error.message || "Failed to update password. Please check your session.");
    } finally {
      stopLoading();
    }
  };

  return (
    <section>
      <Container
        className="d-flex align-items-center justify-content-center login-background"
        fluid
      >
        <div className="login-modal">
          <div className="d-flex flex-column align-items-center justify-content-center mb-3">
            <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" className="login-logo mb-2" />
            <h4 className="text-secondary text-center mt-2 fw-semibold">Update Your Password</h4>
            <p className="text-muted small text-center mb-2">First time logging in? Please update your temporary password to continue.</p>
          </div>

          {serverError && <Alert variant="danger">{serverError}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Row className="px-0 mb-3">
              <InputField
                field="newPassword"
                label="New Password"
                type="password"
                value={newPassword}
                onChange={handleFieldChange}
                error={validationErrors.newPassword}
                as={Col}
                controlId="portalChangeNewPassword"
              />
            </Row>
            <Row className="px-0 mb-3">
              <InputField
                field="confirmPassword"
                label="Confirm Password"
                type="password"
                value={confirmPassword}
                onChange={handleFieldChange}
                error={validationErrors.confirmPassword}
                as={Col}
                controlId="portalChangeConfirmPassword"
              />
            </Row>
            <Button
              className="login-button mt-3 w-100"
              size="xl"
              type="submit"
            >
              Update Password
            </Button>
            <div className="text-center mt-3">
              <a
                href="#logout"
                className="text-decoration-none text-muted small"
                onClick={(e) => {
                  e.preventDefault();
                  localStorage.removeItem("portalToken");
                  navigate("/portal/login");
                }}
              >
                Cancel & Sign Out
              </a>
            </div>
          </Form>
        </div>
      </Container>
    </section>
  );
}

export default PortalChangePassword;
